export default __webpack_public_path__ + "static/logoChristianDior-45c048b78c4beecacff6f5a78530d857.png";